var Utils = require("common/Utils");

function PopupDialog() {
    this.showPopup = function($popup, positionTo) {
        if (positionTo == undefined) {
            positionTo = 'a[href="#' + $popup.attr("id") + '"]';
        }

        // When a page is scrolled and then a popup opened, the pop-up don't appear at the correct position -> reposition it
        var POPUPAFTEROPEN_EVENT_NAME = "popupafteropen.positionCheck";
        $popup.on(POPUPAFTEROPEN_EVENT_NAME, function() {
            $popup.off(POPUPAFTEROPEN_EVENT_NAME);
            $popup.popup("reposition", {positionTo : positionTo});
        });

        // Reset popup attributes after an orientation change
        var popupId = $popup.attr("id");
        var ORIENTATIONCHANGE_EVENT_NAME = "orientationchange." + popupId;
        $(window).on(ORIENTATIONCHANGE_EVENT_NAME, function() {
            var POPUPBEFOREPOSITION_EVENT_NAME = "popupbeforeposition." + popupId;
            $popup.on(POPUPBEFOREPOSITION_EVENT_NAME, function() {
                $popup.off(POPUPBEFOREPOSITION_EVENT_NAME);
                _setPopupAttributes($popup, positionTo);
            });
        });

        // Unregister the orientation change handler after the popup is closed
        var POPUPAFTERCLOSE_EVENT_NAME = "popupafterclose.orientationchange";
        $popup.on(POPUPAFTERCLOSE_EVENT_NAME, function() {
            $popup.off(POPUPAFTERCLOSE_EVENT_NAME);
            $(window).off(ORIENTATIONCHANGE_EVENT_NAME);
        });

        // Set initial popup attributes
        var phoneScreen = _setPopupAttributes($popup, positionTo);

        // Open the popup
        $popup.popup("open", {
            transition : phoneScreen ? "slideup" : "fade",
            positionTo : positionTo
        });
    };

    function _setPopupAttributes($popup) {
        var phoneScreen = !isTabletView();

        // Show a popup above footer in tablet mode
        var $footer = $("#footer");

        if ($footer.length > 0) {
            $popup.css("bottom", (phoneScreen ? $footer.height() : "0") + "px");
        }

        _addScrollingToPopup($popup, phoneScreen, $footer);

        return phoneScreen;
    }

    /** Adds support for vertical scrolling for a given popup
     * The popup can take whole height of the screen in "phone" mode (with a gap for a footer)
     * In "tablet" mode small space is left between the popup and top and bottom end of the screen (or footer is there is any)
     */
    function _addScrollingToPopup($popup, phoneScreen, $footer) {
        var windowHeight = window.innerHeight;

        if (!phoneScreen) {
            // Leave a small space between between the popup and top and bottom end of the screen in "tablet" mode
            windowHeight -= 60;
        }

        // If a footer exists on the page -> make the popup smaller so the footer can be still visible
        if ($footer.length > 0) {
            windowHeight -= $footer.height();
        }

        // Add styling for scrolling
        $popup.find("ul").each(function(index, ul) {
            $(ul).css("max-height", windowHeight + "px");
        });
    }

    function isTabletView() {
        // $.width() can return wrong value in Chrome - use window.innerWidth instead
        return Math.max($(window).width(), window.innerWidth) > 740;
    }
}

module.exports = new PopupDialog();


//////////////////
// WEBPACK FOOTER
// ./common/PopupDialog.js
// module id = 16
// module chunks = 3 4